import React, { useEffect, useRef } from 'react';
import { DefaultTheme } from 'styled-components';

import { ISolution, LayoutProps } from '../huntWordInterface';
import { Container, Row, TextClue } from './styles';

interface RouteProps {
  solutions: ISolution[];
  texto: string[];
  trigger: ISolution[];
  isFinished: boolean;
}

interface piece {
  index: number;
  layout?: LayoutProps;
  texto: string;
  ref: HTMLDivElement;
  isCorrect: boolean;
}

const Clue: React.FC<RouteProps> = ({
  solutions,
  texto,
  trigger,
  isFinished,
}) => {
  const pieces = useRef<piece[]>([]);

  useEffect(() => {
    if (trigger.length > 0 && pieces) {
      pieces.current[trigger[trigger.length - 1].wordId].ref.style.color =
        '#fff';
      pieces.current[
        trigger[trigger.length - 1].wordId
      ].ref.style.backgroundColor = '#7e4f96';
      pieces.current[trigger[trigger.length - 1].wordId].ref.style.paddingLeft =
        '4px';
      pieces.current[
        trigger[trigger.length - 1].wordId
      ].ref.style.paddingRight = '4px';
      pieces.current[
        trigger[trigger.length - 1].wordId
      ].ref.style.textTransform = 'uppercase';
    }
  }, [trigger]);

  const blockStyle = {
    color: `${({ theme }: { theme: DefaultTheme }) => theme.text}`,
    backgroundColor: 'transparent',
  };

  const clueStyle = {
    color: `${({ theme }: { theme: DefaultTheme }) => theme.text}`,
    backgroundColor: 'transparent',
    fontWeight: 'bold',
  };

  const verifyIfIsClue = (element: string) => {
    for (let i = 0; i < solutions.length; i++) {
      if (element.toLowerCase() === solutions[i].solution.toLowerCase()) {
        return true;
      }
    }
    return false;
  };

  const textElement = (texto: string, index: number, isClue?: boolean) => (
    <TextClue
      ref={(ref: HTMLParagraphElement) => {
        if (isClue && isFinished && ref) {
          ref.style.backgroundColor = '#7e4f96';
        }
        if (isClue && ref) {
          ref.style.textTransform = 'uppercase';
        }
        if (!isFinished && ref && isClue) {
          ref.style.backgroundColor = 'transparent';
        }
        pieces.current.push({
          index,
          ref,
          texto,
          isCorrect: false,
          layout: {
            height: ref?.offsetHeight,
            width: ref?.offsetWidth,
            x: ref?.offsetLeft,
            y: ref?.offsetTop,
          },
        });
      }}
      style={isClue ? clueStyle : blockStyle}
      key={index}
    >
      {texto}
    </TextClue>
  );

  //Criação dos blocos
  const createPieces = () => {
    let elements = [];

    for (let i = 0; i < texto.length; i++) {
      elements.push(textElement(texto[i], i, verifyIfIsClue(texto[i])));
    }

    return elements;
  };

  const displayText = createPieces();

  return (
    <Container>
      <Row>{displayText}</Row>
    </Container>
  );
};

export default Clue;
